import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DragAndDropType, DraggableGantType, ItemType } from '../../types';

export interface IGantDraggableState {
    isDragging: boolean;
    currentItemVerticalDraggable: ItemType | null;
    currentItemVerticalDrop: ItemType | null;
    typeOfDragAndDrop: DragAndDropType;
    dragging: DraggableGantType;
    draggingDrop: DraggableGantType;
    currentDragBond: ItemType | null;
    currentDropBond: ItemType | null;
    currentPreDropBond: ItemType | null;
    currentPositionX: number;
    currentPositionY: number;
    currentPeriodPositionX: number;
}

const initialState: IGantDraggableState = {
    isDragging: false,
    currentItemVerticalDraggable: null,
    currentItemVerticalDrop: null,
    typeOfDragAndDrop: 'none',
    dragging: 'none',
    draggingDrop: 'none',
    currentDragBond: null,
    currentDropBond: null,
    currentPreDropBond: null,
    currentPositionX: 0,
    currentPositionY: 0,
    currentPeriodPositionX: 0,
};

export const gantDraggableSlice = createSlice({
    name: 'gantDraggable',
    initialState,
    reducers: {
        setterGantDraggable: (state, action: PayloadAction<Partial<IGantDraggableState>>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setterGantDraggable } = gantDraggableSlice.actions;

export default gantDraggableSlice.reducer;
